import { makeVar } from "@apollo/client"

export const ASSISTANT_EMAIL_TEMPLATE_EDIT_STATE_KEY =
    "assistantEmailTemplateEdit"

export type PendingEmailTemplateAssistantEdit = {
    readonly templateId: string
    readonly toolCallId: string
    readonly subject?: string
    readonly html?: string
    readonly css?: string
}

export const pendingEmailTemplateAssistantEditVar =
    makeVar<PendingEmailTemplateAssistantEdit | null>(null)
